module.exports = __webpack_public_path__ + "media/applicants/full-service-shopper-square-9bd26857.webp";